// --------------------------------------- Project List
// --------------------------------------- Project List
export const ProjectList = [

{
    img: "/tonecraft.png",
    title: "ToneCraft - AI Copywriting Assistant",
    description:
      "Turn any product description into platform-ready marketing copy instantly. Choose your platform (Instagram, LinkedIn, TikTok, Email & more), pick a tone, and let AI craft the perfect message — tailored, fast, and consistent every time.",
    tech_stack: ["Python", "Flask","Groq API", "Render", "GPT-OSS-20B"],
    github_url: "https://github.com/geeky-zee/Tonecraft",
    demo_url: "https://tonecraft-sqwd.onrender.com/",
  },


  {
    img: "/monkiai.jpeg",
    title: "MONKI AI - SMART AI ChatBot",
    description:
      "A smart custom AI chatbot (Monki AI) that leverages advanced natural language processing to provide intelligent, context-aware responses, enhancing user engagement and support",
    tech_stack: ["Python", "Streamlit", "Groq API", "Pillow", "python-dotenv", "GPT-OSS-20B", "Streamlit Community Cloud"],
    github_url: "https://github.com/geeky-zee/Monki-Ai-Chatbot",
    demo_url: "https://monkiai.streamlit.app/?utm_medium=oembed",
  },


  {
    img: "/inboxiq.png",
    title: "InboxIQ - AI Email Automation Agent",
    description:
      "An AI automation agent integrated with Gmail, n8n, and Gemini Flash 2.5 API to auto-sort messages, filter calendar alerts, and manage labels intelligent dynamic logic.",
    tech_stack: ["Next.js", "n8n", "Gemini API", "PostgreSQL", "OAuth"],
    github_url: "https://github.com/geeky-zee",
    demo_url: "https://inboxiqai.vercel.app/",
  },
  {
    img: "/todo.png",
    title: "To-Do - Advanced Task Manager App",
    description:
      "A cross-platform mobile application featuring intelligent task organization, priority levels, and Firestore real-time storage.",
    tech_stack: ["React Native", "Firebase", "Firestore", "JavaScript"],
    github_url: "https://github.com/geeky-zee",
    demo_url: "https://appetize.io/embed/b_2f2u4a6gilwibb2bfpbyu3pp6a?centered=true&scale=auto",
  },
  {
    img: "/creationz.png",
    title: "Creationz Agency Platform",
    description:
      "Official website for Creationz digital business showcase featuring live client projects, dynamic services list, and real-time status updates.",
    tech_stack: ["React", "JavaScript", "JSX", "TailwindCSS"],
    github_url: "https://github.com/geeky-zee/creationz-website",
    demo_url: "https://creationzweb.vercel.app/",
  },
  /*{
    img: "/world-hunt.png",
    title: "World Hunt - 2D/3D Game",
    description:
      "A game built initially in Assembly Language for low-level architecture understanding and expanded into Unity 3D with interactive mechanics.",
    tech_stack: ["Unity 3D", "C#", "Assembly Language"],
    github_url: "https://github.com/geeky-zee",
    demo_url: "",
  },*/
];
 /* {
    img: "/jobDetect.png",
    title: "JobDetect",
    description:
      "An app to detect if a job posting is a scam or not using its description.",
    tech_stack: ["HTML", "CSS", "JAVASCRIPT", "REACT"],
    github_url: "https://github.com/salesp07/JobDetectNode",
    demo_url: "https://jobdetective.onrender.com/",
  },*/


// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    name: "NextJs",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    name: "React Native",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
   {
    img: "https://cdn.simpleicons.org/firebase",
    name: "Firebase",
  },
 /* {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },*/
 /* {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },*/
 /* {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
    name: "Flask",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C++",
  },
 /* {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },*/
  /*{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  /*{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },*/
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  
{
    img: "https://cdn.simpleicons.org/tailwindcss",
    name: "TailwindCSS",
  },

  {
    img: "https://cdn.simpleicons.org/python",
    name: "Python",
  },

  {
    img: "https://cdn.simpleicons.org/flask",
    name: "Flask",
  },

  {
    img: "https://cdn.simpleicons.org/streamlit",
    name: "Streamlit",
  },

  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  {
    img: "https://cdn.simpleicons.org/n8n",
    name: "n8n AI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg",
    name: "GitHub",
  },
{
    img: "https://cdn.simpleicons.org/androidstudio",
    name: "AndroidStudio",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vercel/vercel-original.svg",
    name: "Vercel",
  },
{
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/unity/unity-original.svg",
    name: "Unity 3D",
  },

  {
    img: "https://cdn.simpleicons.org/supabase",
    name: "Supabase",
  },

  {
    img: "https://cdn.simpleicons.org/ngrok",
    name: "ngrok",
  },
  {
    img: "https://cdn.simpleicons.org/ubuntu",
    name: "Ubuntu",
  },
  {
    img: "https://cdn.simpleicons.org/discord",
    name: "Discord",
  },




];
